import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CampaignService = {
  // Get all campaigns with pagination and filtering
  campaignsList: async ({
    name,
    isActive,
    isDraft,
    startDateFrom,
    startDateTo,
    pageNumber = 1,
    pageSize = 10,
  } = {}) => {
    const filterList = [];
    if (name && name.trim())
      filterList.push(`name=${encodeURIComponent(name.trim())}`);
    if (isActive !== undefined && isActive !== "")
      filterList.push(`isActive=${isActive}`);
    if (startDateFrom)
      filterList.push(`startDateFrom=${encodeURIComponent(startDateFrom)}`);
    if (startDateTo)
      filterList.push(`startDateTo=${encodeURIComponent(startDateTo)}`);
    if (isDraft !== undefined && isDraft !== "")
      filterList.push(`isDraft=${isDraft}`);
    if (pageNumber) filterList.push(`pageNumber=${pageNumber}`);
    if (pageSize) filterList.push(`pageSize=${pageSize}`);

    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/campaign${filterString}`);
    return response.data;
  },

  // Create a new campaign
  create: async (data) => {
    try {
      const response = await apiService.post("/campaign", data);
      return response.data;
    } catch (error) {
      console.error("Error creating campaign:", error);
      throw error;
    }
  },

  // Get campaign by id
  getCampaignById: async (id) => {
    try {
      const response = await apiService.get(`/campaign/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign:", error);
      throw error;
    }
  },

  // Update a campaign
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/campaign/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating campaign:", error);
      throw error;
    }
  },

  // Delete a campaign
  delete: async (id) => {
    try {
      const response = await apiService.delete(`/campaign`, {
        params: { campaignId: id },
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting campaign:", error);
      throw error;
    }
  },

  // Get campaign statistics
  getCampaignStats: async ({
    startDate,
    endDate,
    campaignId,
  } = {}) => {
    try {
      const filterList = [];
      if (startDate)
        filterList.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate)
        filterList.push(`endDate=${encodeURIComponent(endDate)}`);
      if (campaignId)
        filterList.push(`campaignId=${campaignId}`);

      const filterString =
        filterList.length > 0 ? `?${filterList.join("&")}` : "";
      const response = await apiService.get(`/itouch/campaign-stats${filterString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign stats:", error);
      throw error;
    }
  },

  // Update campaign status (publish/unpublish)
  updateCampaignStatus: async (id, isDraft) => {
    try {
      const response = await apiService.put(
        `/campaign/campaign-status/${id}?isDraft=${isDraft}`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating campaign status:", error);
      throw error;
    }
  },
};

export default CampaignService;
